// extracted by mini-css-extract-plugin
module.exports = {"main-container":"EditPromo_main-container__36hEh","left-container":"EditPromo_left-container__36kNo","right-container":"EditPromo_right-container__3NlpA"};